import { RoutingLayerType } from 'gql/generated/graphql'
import { TRGBAColor, TRGBColor } from 'types/maps'

export interface IRoutingLayerModel {
  id: string
  name: string
  type: RoutingLayerType
  createdDate: Date
  isActive: boolean
}

export interface IRoutingLayersCollection {
  items: IRoutingLayerModel[]
}

export interface IPolygon {
  id: string
  color: TRGBColor
  fillColor: TRGBAColor
  lineColor: TRGBAColor
  lineWidth: number
  transparency: number
  label: string
  contour: number[][]
  coordinates: {
    latitude: number
    longitude: number
  }[]
}
export interface IPolygonsLayerModel {
  id: string
  name: string
  polygons: IPolygon[]
}
export interface IPolygonsLayersCollection {
  items: IPolygonsLayerModel[]
  isEmpty: boolean
}

export const ELocationLayerIcon = {
  CIRCLE: 'circle'
} as const
export type ELocationLayerIcon = (typeof ELocationLayerIcon)[keyof typeof ELocationLayerIcon]

export interface ILocation {
  id: string
  label: string
  coordinates: {
    latitude: number
    longitude: number
  }
  deckCoordinates: [number, number]
}
export interface ILocationsLayerModel {
  id: string
  name: string
  locationsGroup: {
    id: string
    color: TRGBColor
    icon: ELocationLayerIcon
    locations: ILocation[]
  }
}

export interface ILocationsLayersCollection {
  items: ILocationsLayerModel[]
  isEmpty: boolean
}

export interface IAddDatasetLayerForm {
  name: string
  file: File | null
}

export interface IEditRoutingLayerForm {
  name: string
}
